(function () {
  const isCollectionPage = () => window.location.pathname.includes('/collections/');

  // Scroll-Position beim Klick auf Produkt speichern
  document.addEventListener('click', function (e) {
    if (!isCollectionPage()) return;
    const link = e.target.closest('a[href*="/products/"]');
    if (link) {
      sessionStorage.setItem('collectionScrollY', window.scrollY);
    }
  });

  // pageshow feuert sowohl beim normalen Laden als auch beim bfcache-Restore (iOS Safari)
  window.addEventListener('pageshow', function (e) {
    if (!isCollectionPage()) return;
    const savedScroll = sessionStorage.getItem('collectionScrollY');
    if (savedScroll) {
      // Kurzes Timeout nötig, damit iOS den DOM vollständig wiederhergestellt hat
      setTimeout(function () {
        window.scrollTo(0, parseInt(savedScroll, 10));
        sessionStorage.removeItem('collectionScrollY');
      }, 50);
    }
  });
})();